import React, { useCallback } from 'react';

import { dispatchMessage, MessagingEvents } from '@services/messagingService';

import { useDeleteVoucherAwaitable } from '../../../services';
import { CartActions, ECartActions, IRemoveVoucherAction } from '../model';

export const useRemoveVoucher = (dispatch: React.Dispatch<CartActions>) => {
  const { request } = useDeleteVoucherAwaitable();

  return useCallback(
    async (data: IRemoveVoucherAction) => {
      const deleteVoucherResponse = await request({ code: data.code });

      if (deleteVoucherResponse) {
        dispatch({ actionType: ECartActions.UPDATE_VOUCHER, payload: deleteVoucherResponse.data });
        dispatchMessage({ event: MessagingEvents.ECartManipulationEvents.CART_UPDATE_EVENT });
      }
    },
    [dispatch, request],
  );
};
